import { render, staticRenderFns } from "./MetricsDropDown.vue?vue&type=template&id=2db5f3e2&scoped=true&"
import script from "./MetricsDropDown.vue?vue&type=script&lang=js&"
export * from "./MetricsDropDown.vue?vue&type=script&lang=js&"
import style0 from "./MetricsDropDown.vue?vue&type=style&index=0&id=2db5f3e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db5f3e2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VListGroup } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VListGroup,VListItem,VListItemTitle})
